import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import PropTypes from "prop-types";
import { SignOut } from "@phosphor-icons/react";

const PermissionsModal = ({ show, onCloseClick, permissions }) => {
	// Sort permissions by module name, then by action name
	const sortedPermissions = [...permissions].sort((a, b) => {
		const moduleA = a.action.module?.name?.toLowerCase() || "";
		const moduleB = b.action.module?.name?.toLowerCase() || "";
		const actionA = a.action.name?.toLowerCase() || "";
		const actionB = b.action.name?.toLowerCase() || "";

		if (moduleA < moduleB) return -1;
		if (moduleA > moduleB) return 1;
		if (actionA < actionB) return -1;
		if (actionA > actionB) return 1;
		return 0;
	});

	return (
		<Modal isOpen={show} toggle={onCloseClick}>
			<ModalHeader toggle={onCloseClick}>Permissões</ModalHeader>
			<ModalBody>
				{sortedPermissions && sortedPermissions.length > 0 ? (
					sortedPermissions.map((permission, index) => (
						<div key={index}>
							{permission.action.module?.name} /{" "}
							{permission.action.name}
						</div>
					))
				) : (
					<div>Nenhuma permissão encontrada.</div>
				)}
			</ModalBody>
			<ModalFooter>
				<Button
					style={{
						background: "none",
						padding: 10,
						cursor: "pointer",
						color: "black",
						marginLeft: 10,
						width: 150,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						gap: 2,
					}}
					onClick={onCloseClick}
				>
					<SignOut size={16} /> Fechar
				</Button>
			</ModalFooter>
		</Modal>
	);
};

PermissionsModal.propTypes = {
	show: PropTypes.bool.isRequired,
	onCloseClick: PropTypes.func.isRequired,
	permissions: PropTypes.array.isRequired,
};

export default PermissionsModal;
